export default __webpack_public_path__ + "static/media/gem_set_6.c73bba74.svg";